import { Browser } from '@capacitor/browser';

export const openUrlInWeb = async (url: 'privacy' | 'terms') =>
  await Browser.open({ url: `https://eventmaker.app/${url}` });
